import { FC, useMemo } from 'react';

import { MassMessageRole } from 'models';

import keyBy from 'lodash/keyBy';
import has from 'lodash/has';

import RoleItem from '../role-item';

import { useStyles as useCommonStyles } from '../style';

interface RolesListProps {
  disabled: boolean;
  roles: MassMessageRole[];
  selectedRoles: MassMessageRole[];
  onSelectRoles?: (roles: MassMessageRole[], checked: boolean) => void;
}

const RolesList: FC<RolesListProps> = ({
  disabled,
  roles,
  selectedRoles,
  onSelectRoles,
}) => {
  const commonClasses = useCommonStyles();

  const selectedRolesDict = useMemo(
    () => keyBy(selectedRoles, 'Id'),
    [selectedRoles]
  );

  return (
    <ul className={commonClasses.ul}>
      {roles.map((role) => {
        const isSelected = has(selectedRolesDict, role.Id);

        return (
          <RoleItem
            key={role.Id}
            role={role}
            disabled={disabled}
            selected={isSelected}
            onSelectRole={onSelectRoles}
          />
        );
      })}
    </ul>
  );
};

export default RolesList;
